import React, { useEffect } from "react";

export const Modal = ({
  open,
  onClose,
  children,
  title,
  description,
  contentClassName = "",
}) => {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      onClick={onClose}
    >
      <div
        className={`bg-white rounded-xl shadow-lg p-6 max-h-[80%] w-[900px] max-w-[95vw] overflow-y-auto no-scrollbar ${contentClassName}`}
        onClick={(e) => e.stopPropagation()}
      >
        {title && <h2 className="text-lg font-bold">{title}</h2>}
        {description && <p className="text-sm text-gray-500">{description}</p>}
        <div className="mt-4">{children}</div>
      </div>
    </div>
  );
};
